import { render } from "./PricingView.vue?vue&type=template&id=3559df52"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__